export default "__VITE_ASSET__CSIcr_9d__"